import { render, staticRenderFns } from "./CancelReservations.vue?vue&type=template&id=2d29142e"
import script from "./CancelReservations.vue?vue&type=script&lang=js"
export * from "./CancelReservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports